module.exports = __webpack_public_path__ + "img/shield-user-line-trans.79b0b371.svg";